import * as Common from '../Common/modules'
import * as Models from '../Models'

export interface IApplicationStatusApiClient {
    IsAppOnline: () => ng.IPromise<Models.AppStatusResponse>;
}

export class ApplicationStatusApiClient implements IApplicationStatusApiClient {

    private baseUrl = 'api/';
    public static $inject = ['ApiClient'];
    constructor(private apiClient: Common.ApiClientService.Igs.Common.IApiClientService) {}

    public IsAppOnline = (): ng.IPromise<Models.AppStatusResponse> => {
        return this.apiClient.get(this.baseUrl + 'IsAppOnline');
    };
}
